module.exports = __webpack_public_path__ + "img/news.51ae5a15.png";